import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/InputTemplate.scss";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import RiskExcelImport from "./RiskExcelImport";
import { CircularProgress } from "@mui/material";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Api from "../../Services/Api";
import Images from "../../Assets/Images";
import { toastr } from "react-redux-toastr";
import ActionExcelImport from "./ActionExcelImport";
import { Popup } from "@progress/kendo-react-popup";
import TaskExcelImport from "../Tasks/TaskExcelImport";
import ActivityExcelImport from "../Tasks/ActivityExcelImport";
export default class DataUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "LIST",
      selected: 0,
      loader: false,
      templateId: 0,
      Deletepopup: false,
      deleteid: "",
      riskExcelTemplates: [],
      actionExcelTemplates: [],
      taskExcelTemplates: [],
      activityExcelTemplates: [],
      skip: 0,
      take: 10,
    };
  }

  componentDidMount = () => {
    this.getExcelTemplates();
  };

  getExcelTemplates = async () => {
    try {
      let response = await Api.getExcelTemplates();
      if (response.status === 200) {
        this.setState({
          ...this.state,
          riskExcelTemplates: response.excelTemplates.filter(
            (item) => item.templateType === "risk"
          ),
          actionExcelTemplates: response.excelTemplates.filter(
            (item) => item.templateType === "action"
          ),
          taskExcelTemplates: response.excelTemplates.filter(
            (item) => item.templateType === "task"
          ),
          activityExcelTemplates: response.excelTemplates.filter(
            (item) => item.templateType === "taskaction"
          ),
        });
      } else {
        this.setState({
          ...this.state,
          riskExcelTemplates: [],
          actionExcelTemplates: [],
          taskExcelTemplates: [],
          activityExcelTemplates: [],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  handleCreateTemplate = (value) => {
    this.setState({
      title: value,
    });
  };
  handleclose = () => {
    this.setState({
      title: "LIST",
      templateId: 0,
    });
    this.getExcelTemplates();
  };

  handleSelect = (e) => {
    this.setState({
      selected: e.selected,
      skip: 0,
      take: 10,
    });
  };
  deleteTemplate = async () => {
    try {
      const dataItem = this.state.deleteid;
      let req = {
        TemplateId: dataItem.templateId,
      };
      let response = await Api.deleteExcelTemplate(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.getExcelTemplates();
        this.setState({
          Deletepopup: !this.state.Deletepopup,
        });
      } else {
        toastr.error(response.message);
        this.setState({
          Deletepopup: !this.state.Deletepopup,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  enabledelete = (id, value) => {
    this.setState({ Deletepopup: !this.state.Deletepopup, deleteid: id });
  };
  closeWidgetDeletePopup = () => {
    this.setState({ Deletepopup: !this.state.Deletepopup });
  };
  actionButtonsRisk = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        <ul className="actionIcon">
          <li onClick={() => this.enabledelete(eventData)}>
            <a title="Delete" className="redbtn icon">
              <img src={Images.TRASH} width="12" alt="Trash" />
            </a>
          </li>
          <li onClick={() => this.editTemplateRisk(eventData)}>
            <a title="Edit" className="redbtn icon">
              <img src={Images.EDITICON} width="12" alt="Edit" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  actionButtonsAction = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        <ul className="actionIcon">
          <li onClick={() => this.enabledelete(eventData)}>
            <a title="Delete" className="redbtn icon">
              <img src={Images.TRASH} width="12" alt="Trash" />
            </a>
          </li>
          <li onClick={() => this.editTemplateAction(eventData)}>
            <a title="Edit" className="redbtn icon">
              <img src={Images.EDITICON} width="12" alt="Edit" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  actionButtonsTask = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        <ul className="actionIcon">
          <li onClick={() => this.enabledelete(eventData)}>
            <a title="Delete" className="redbtn icon">
              <img src={Images.TRASH} width="12" alt="Trash" />
            </a>
          </li>
          <li onClick={() => this.editTemplateTask(eventData)}>
            <a title="Edit" className="redbtn icon">
              <img src={Images.EDITICON} width="12" alt="Edit" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  actionButtonsActivity = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        <ul className="actionIcon">
          <li onClick={() => this.enabledelete(eventData)}>
            <a title="Delete" className="redbtn icon">
              <img src={Images.TRASH} width="12" alt="Trash" />
            </a>
          </li>
          <li onClick={() => this.editTemplateActivity(eventData)}>
            <a title="Edit" className="redbtn icon">
              <img src={Images.EDITICON} width="12" alt="Edit" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  editTemplateRisk = async (dataItem) => {
    try {
      this.setState({
        title: "RISK",
        templateId: dataItem.templateId,
      });
    } catch (err) {
      console.error(err);
    }
  };
  editTemplateAction = async (dataItem) => {
    try {
      this.setState({
        title: "ACTION",
        templateId: dataItem.templateId,
      });
    } catch (err) {
      console.error(err);
    }
  };
  editTemplateTask = async (dataItem) => {
    try {
      this.setState({
        title: "TASK",
        templateId: dataItem.templateId,
      });
    } catch (err) {
      console.error(err);
    }
  };
  editTemplateActivity = async (dataItem) => {
    try {
      this.setState({
        title: "ACTIVITY",
        templateId: dataItem.templateId,
      });
    } catch (err) {
      console.error(err);
    }
  };
  render() {
    const { title } = this.state;
    return (
      <div
        style={{
          margin: "4px",
          backgroundColor: "#1f2222b0",
        }}
      >
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {title === "LIST" && (
          <div className="impactsTableCont" id="impactsTableCont">
            <TabStrip
              selected={this.state.selected}
              onSelect={this.handleSelect}
            >
              <TabStripTab title="Risk Template">
                <div className="risktemplate">
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div className="risktemplateheader">Risk Template</div>
                    <div
                      className="addrisktemplate"
                      onClick={() => this.handleCreateTemplate("RISK")}
                    >
                      Add Risk Template
                    </div>
                  </div>
                  <div className="tblCont dataGrids">
                    <div className="rw-tab-content" id="risktemplate">
                      <Grid
                        data={this.state.riskExcelTemplates.slice(
                          this.state.skip,
                          this.state.take + this.state.skip
                        )}
                        skip={this.state.skip}
                        take={this.state.take}
                        total={this.state.riskExcelTemplates.length}
                        onPageChange={this.pageChange}
                        pageable={true}
                        reorderable
                        resizable
                      >
                        <GridColumn
                          field="templateName"
                          title="Risk Template Name"
                          width="160px"
                        ></GridColumn>
                        <GridColumn
                          field="templateDescription"
                          title="Description"
                          width="500px"
                          cell={(props) => (
                            <td title={props.dataItem.templateDescription}>
                              <span>{props.dataItem.templateDescription}</span>
                            </td>
                          )}
                        ></GridColumn>
                        <GridColumn
                          field="Actions"
                          title="Actions"
                          cell={this.actionButtonsRisk}
                          width="120px"
                        ></GridColumn>
                      </Grid>
                    </div>
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab title="Action Template">
                <div className="actiontemplate">
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div className="Actiontemplateheader">Action Template</div>
                    <div
                      className="addActiontemplate"
                      onClick={() => this.handleCreateTemplate("ACTION")}
                    >
                      Add Action Template
                    </div>
                  </div>
                  <div className="tblCont dataGrids">
                    <div className="rw-tab-content" id="actiontemplate">
                      <Grid
                        data={this.state.actionExcelTemplates.slice(
                          this.state.skip,
                          this.state.take + this.state.skip
                        )}
                        skip={this.state.skip}
                        take={this.state.take}
                        total={this.state.actionExcelTemplates.length}
                        onPageChange={this.pageChange}
                        pageable={true}
                        reorderable
                        resizable
                      >
                        <GridColumn
                          field="templateName"
                          title="Risk Template Name"
                          width="160px"
                        ></GridColumn>
                        <GridColumn
                          field="templateDescription"
                          title="Description"
                          width="500px"
                          cell={(props) => (
                            <td title={props.dataItem.templateDescription}>
                              <span>{props.dataItem.templateDescription}</span>
                            </td>
                          )}
                        ></GridColumn>
                        <GridColumn
                          field="Actions"
                          title="Actions"
                          cell={this.actionButtonsAction}
                          width="120px"
                        ></GridColumn>
                      </Grid>
                    </div>
                  </div>
                </div>
              </TabStripTab>
              {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                <TabStripTab title="Task Template">
                  <div className="actiontemplate">
                    <div style={{ display: "flex", marginBottom: "10px" }}>
                      <div className="Actiontemplateheader">Task Template</div>
                      <div
                        className="addActiontemplate"
                        onClick={() => this.handleCreateTemplate("TASK")}
                      >
                        Add Task Template
                      </div>
                    </div>
                    <div className="tblCont dataGrids">
                      <div className="rw-tab-content" id="actiontemplate">
                        <Grid
                          data={this.state.taskExcelTemplates.slice(
                            this.state.skip,
                            this.state.take + this.state.skip
                          )}
                          skip={this.state.skip}
                          take={this.state.take}
                          total={this.state.taskExcelTemplates.length}
                          onPageChange={this.pageChange}
                          pageable={true}
                          reorderable
                          resizable
                        >
                          <GridColumn
                            field="templateName"
                            title="Task Template Name"
                            width="160px"
                          ></GridColumn>
                          <GridColumn
                            field="templateDescription"
                            title="Description"
                            width="500px"
                            cell={(props) => (
                              <td title={props.dataItem.templateDescription}>
                                <span>
                                  {props.dataItem.templateDescription}
                                </span>
                              </td>
                            )}
                          ></GridColumn>
                          <GridColumn
                            field="Actions"
                            title="Actions"
                            cell={this.actionButtonsTask}
                            width="120px"
                          ></GridColumn>
                        </Grid>
                      </div>
                    </div>
                  </div>
                </TabStripTab>
              ) : (
                ""
              )}
              {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                <TabStripTab title="Activity Template">
                  <div className="actiontemplate">
                    <div style={{ display: "flex", marginBottom: "10px" }}>
                      <div className="Actiontemplateheader">
                        Activity Template
                      </div>
                      <div
                        className="addActiontemplate"
                        onClick={() => this.handleCreateTemplate("ACTIVITY")}
                      >
                        Add Activity Template
                      </div>
                    </div>
                    <div className="tblCont dataGrids">
                      <div className="rw-tab-content" id="actiontemplate">
                        <Grid
                          data={this.state.activityExcelTemplates.slice(
                            this.state.skip,
                            this.state.take + this.state.skip
                          )}
                          skip={this.state.skip}
                          take={this.state.take}
                          total={this.state.activityExcelTemplates.length}
                          onPageChange={this.pageChange}
                          pageable={true}
                          reorderable
                          resizable
                        >
                          <GridColumn
                            field="templateName"
                            title="Activity Template Name"
                            width="160px"
                          ></GridColumn>
                          <GridColumn
                            field="templateDescription"
                            title="Description"
                            width="500px"
                            cell={(props) => (
                              <td title={props.dataItem.templateDescription}>
                                <span>
                                  {props.dataItem.templateDescription}
                                </span>
                              </td>
                            )}
                          ></GridColumn>
                          <GridColumn
                            field="Actions"
                            title="Actions"
                            cell={this.actionButtonsActivity}
                            width="120px"
                          ></GridColumn>
                        </Grid>
                      </div>
                    </div>
                  </div>
                </TabStripTab>
              ) : (
                ""
              )}
            </TabStrip>
          </div>
        )}
        {title === "RISK" ? (
          <RiskExcelImport
            {...this.props}
            handleclose={this.handleclose}
            templateId={this.state.templateId}
          />
        ) : (
          ""
        )}
        {title === "ACTION" ? (
          <div>
            <ActionExcelImport
              {...this.props}
              handleclose={this.handleclose}
              templateId={this.state.templateId}
            />
          </div>
        ) : (
          ""
        )}

        {title === "TASK" &&
        secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
          <div>
            <TaskExcelImport
              {...this.props}
              handleclose={this.handleclose}
              templateId={this.state.templateId}
            />
          </div>
        ) : (
          ""
        )}
        {title === "ACTIVITY" &&
        secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
          <div>
            <ActivityExcelImport
              {...this.props}
              handleclose={this.handleclose}
              templateId={this.state.templateId}
            />
          </div>
        ) : (
          ""
        )}
        <Popup show={this.state.Deletepopup} popupClass={"popup-content"}>
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure You want to delete this template.</h3>
            <div className="btnCont">
              <button
                onClick={this.deleteTemplate}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeWidgetDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
